import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { canchasDeJornada, etiquetaDeJornada, jornadasDeRueda } from "./jornadas";
import { generarCartelesCanchas } from "./cartelesCanchas";
import { nombreDeCancha } from "./horarios";
import { toastBigError } from "components/utils/toasts";

// Pregunta de qué jornada de la rueda se generan los carteles de cancha. No hace
// falta elegir turno: el cartel es el mismo todo el día, así que sale una hoja
// por cada cancha que se usa en la jornada.
export default function CartelesCanchasModal({ isOpen, round, torneoNombre, torneoAno, onClose }) {
  const jornadas = React.useMemo(() => jornadasDeRueda(round), [round]);
  const [dia, setDia] = React.useState("");
  const [generando, setGenerando] = React.useState(false);

  // Al abrir se propone la jornada más reciente.
  React.useEffect(() => {
    if (isOpen) setDia(jornadas.length ? jornadas[0].dia : "");
  }, [isOpen, jornadas]);

  const jornada = jornadas.find((j) => j.dia === dia) || null;
  const canchas = React.useMemo(() => (jornada ? canchasDeJornada(jornada.partidos) : []), [jornada]);

  const generar = async () => {
    if (!jornada || canchas.length === 0) return;
    setGenerando(true);
    try {
      await generarCartelesCanchas({
        canchas,
        torneoNombre,
        torneoAno,
        numero: jornada.numero,
        dia: jornada.dia,
      });
      onClose();
    } catch (ex) {
      toastBigError("No se pudieron generar los carteles", "Intentá de nuevo en un momento.");
    } finally {
      setGenerando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Carteles Canchas</ModalHeader>
      <ModalBody>
        {jornadas.length === 0 ? (
          <p className="text-muted mb-0" style={{ fontSize: "0.875rem" }}>
            Las zonas de esta rueda todavía no tienen fechas con día asignado.
          </p>
        ) : (
          <React.Fragment>
            <div className="form-group">
              <label className="font-weight-bold" style={{ fontSize: "0.8125rem" }}>
                Fecha
              </label>
              <select className="form-control" value={dia} onChange={(e) => setDia(e.target.value)}>
                {jornadas.map((j) => (
                  <option key={j.dia} value={j.dia}>
                    {etiquetaDeJornada(j)}
                  </option>
                ))}
              </select>
            </div>

            <p className="text-muted mb-0" style={{ fontSize: "0.8125rem" }}>
              {canchas.length === 0
                ? "Esa fecha todavía no tiene partidos con cancha asignada."
                : "Sale una hoja por cancha: " + canchas.map((c) => nombreDeCancha(c)).join(", ") + "."}
            </p>
          </React.Fragment>
        )}
      </ModalBody>
      <ModalFooter>
        <Button className="btn-arhock btn-sm my-0" style={{ opacity: 0.55 }} onClick={onClose}>
          Cancelar
        </Button>
        <Button
          className="btn-arhock btn-sm my-0"
          onClick={generar}
          disabled={canchas.length === 0 || generando}
        >
          {generando ? "Generando..." : "Generar"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
